import { createContext } from "react";
// Creating context
const noteContext = createContext();

export default noteContext;